
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { queryClient } from './lib/query-client'
import App from './App.tsx'
import './index.css'

const helmetContext = {};

const container = document.getElementById('root');

// Vérifier que l'élément root existe
if (!container) {
  console.error("Élément root non trouvé!");
} else {
  try {
    const root = createRoot(container);
    
    root.render(
      <QueryClientProvider client={queryClient}>
        <HelmetProvider context={helmetContext}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </QueryClientProvider>
    );
    
    console.log("Application rendue avec succès");
  } catch (error) {
    console.error("Erreur lors du rendu de l'application:", error);
  }
}
